import { render, staticRenderFns } from "./framework-sidebar-menu-item.vue?vue&type=template&id=5f850e12&"
import script from "./framework-sidebar-menu-item.vue?vue&type=script&lang=js&"
export * from "./framework-sidebar-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports